var styles = {"spinner":"bc-exercise-loading__spinner"};

export { styles as default };
